import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=ea2b3760&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=ea2b3760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2b3760",
  null
  
)

export default component.exports